var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path, _path2, _path3, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _path4, _path5, _path6, _path7, _path8, _g35, _g36, _g37, _path9, _path10, _path11, _path12, _path13, _g38, _g39, _g40, _path14, _path15, _path16, _path17, _path18, _g41, _g42, _g43, _g44, _g45, _g46, _path19, _path20, _path21, _g47, _g48, _g49, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g50, _g51, _path30, _path31, _path32, _path33, _path34, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _path35, _path36, _path37, _path38, _path39, _g60, _path40, _path41, _path42, _path43, _path44, _g61, _path45, _path46, _path47, _g62, _g63, _g64, _g65, _path48, _path49, _path50, _path51, _path52, _path53, _a, _a2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBePhase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1298.35 1626.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-BE-P3, .cls-2-BE-P3, .cls-3-BE-P3, .cls-4-BE-P3 {\n        fill: #fff;\n      }\n      .cls-4-BE-P3-NA{\n        fill:#d3d3d3;\n      }\n      .cls-1-BE-P3, .cls-5-BE-P3, .cls-6-BE-P3 {\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .cls-7-BE-P3 {\n        fill: url(#linear-gradient-3-BE-P3);\n      }\n\n      .cls-7-BE-P3, .cls-8-BE-P3, .cls-9-BE-P3, .cls-10-BE-P3, .cls-4-BE-P3, .cls-11-BE-P3 {\n        stroke: #008573;\n      }\n\n      .cls-12-BE-P3, .cls-13-BE-P3, .cls-14-BE-P3, .cls-3-BE-P3, .cls-15-BE-P3, .cls-16-BE-P3, .cls-17-BE-P3, .cls-18-BE-P3 {\n        stroke-width: 0px;\n      }\n\n      .cls-12-BE-P3, .cls-8-BE-P3, .cls-10-BE-P3 {\n        fill: #008573;\n      }\n\n      .cls-2-BE-P3, .cls-19-BE-P3 {\n        stroke: #4c535d;\n        stroke-width: .2px;\n      }\n\n      .cls-20-BE-P3 {\n        fill: url(#linear-gradient-2-BE-P3);\n      }\n\n      .cls-20-BE-P3, .cls-21-BE-P3 {\n        stroke: #1071e5;\n      }\n\n      .cls-19-BE-P3, .cls-18-BE-P3 {\n        fill: #e81313;\n      }\n\n      .cls-5-BE-P3 {\n        fill: #ffe342;\n      }\n\n      .cls-8-BE-P3, .cls-21-BE-P3 {\n        stroke-width: .05px;\n      }\n\n      .cls-9-BE-P3 {\n        fill: url(#linear-gradient-BE-P3);\n      }\n\n      .cls-14-BE-P3 {\n        fill: #333;\n      }\n\n      .cls-21-BE-P3, .cls-17-BE-P3 {\n        fill: #1071e5;\n      }\n\n      .cls-6-BE-P3 {\n        fill: #1a3378;\n      }\n\n      .cls-15-BE-P3 {\n        fill: #2f5496;\n      }\n\n      .cls-16-BE-P3 {\n        fill: #3a414a;\n      }\n\n      .cls-11-BE-P3 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-BE-P3",
    x1: 502.02,
    y1: 1994.97,
    x2: 502.02,
    y2: 1826.31,
    gradientTransform: "translate(81.49 2146.27) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-BE-P3",
    x1: 17.03,
    y1: 1959.97,
    x2: 17.03,
    y2: 1861.31,
    gradientTransform: "translate(81.49 2146.27) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-BE-P3",
    x1: 502.02,
    y1: 1409.62,
    x2: 502.02,
    y2: 1240.97,
    gradientTransform: "translate(81.49 2146.27) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3",
    d: "m411.53,1224.52c0-3.31,2.69-6,6-6h330.27c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.28c-3.31,0-6-2.69-6-6v-86.67Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-16-BE-P3",
    d: "m439.12,1256.98l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31Zm-2.58-6.72l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-16-BE-P3",
    d: "m447.27,1243.81c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-16-BE-P3",
    d: "m462.41,1256.98h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-16-BE-P3",
    d: "m468.93,1241.3v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-16-BE-P3",
    d: "m481.83,1247.27c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-16-BE-P3",
    d: "m491.67,1243.81c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "cls-16-BE-P3",
    d: "m507.29,1240.14c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84Zm2.24,15.01c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "cls-16-BE-P3",
    d: "m535.4,1244.15c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "cls-16-BE-P3",
    d: "m547.76,1242.04v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "cls-16-BE-P3",
    d: "m564.33,1253.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "cls-16-BE-P3",
    d: "m573.9,1243.81c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "cls-16-BE-P3",
    d: "m595.29,1243.81c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "cls-16-BE-P3",
    d: "m606.77,1257.25c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m623.81,1247.27c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "cls-16-BE-P3",
    d: "m634.06,1245.51c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "cls-16-BE-P3",
    d: "m656.81,1254.54c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m669.98,1247.27c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m682.2,1247.27c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m692.05,1243.81c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m702.85,1253.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "cls-16-BE-P3",
    d: "m719.28,1241.09c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m726,1243.81c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "cls-16-BE-P3",
    d: "m740.53,1245.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "cls-16-BE-P3",
    d: "m510.89,1273.48c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "cls-16-BE-P3",
    d: "m518.9,1271.38v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "cls-16-BE-P3",
    d: "m545.79,1286.32l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "cls-16-BE-P3",
    d: "m564.19,1274.16c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m583.75,1283.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "cls-16-BE-P3",
    d: "m595.56,1273.14c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "cls-16-BE-P3",
    d: "m609.14,1273.14c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m622.65,1275.25c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-3",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m629.78,1273.14c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "cls-16-BE-P3",
    d: "m643.91,1286.32h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-3",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m658.37,1283.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "cls-16-BE-P3",
    d: "m664.01,1286.32v-17.72h2.17v17.72h-2.17"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3",
    d: "m411.97,6.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "cls-16-BE-P3",
    d: "m520.66,55.65v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "cls-16-BE-P3",
    d: "m533.15,42.48c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m540.42,39.96v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m548.16,52.46c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-3",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m552.57,39.96v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-4",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m565.88,53.2c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m573.89,52.46c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m583.47,42.48c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aE-2",
    "data-name": "aE",
    className: "cls-16-BE-P3",
    d: "m613.34,55.65l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "cls-16-BE-P3",
    d: "m619.39,55.65v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "cls-16-BE-P3",
    d: "m646.75,43.63c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82Zm-11.54,3.26c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "diamond1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9-BE-P3",
    d: "m578.13,153.95c3.39-1.67,7.37-1.67,10.76,0l160.36,79.03c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.35,79.04c-3.4,1.67-7.38,1.67-10.77,0l-160.36-79.05c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.02Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "cls-3-BE-P3",
    d: "m531.95,240.45l.14-13.85-4.35,13.85h-2.51l-4.28-13.85.14,13.85h-3.12v-16.84h4.75l3.8,12.56,3.87-12.56h4.69v16.84h-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "cls-3-BE-P3",
    d: "m538.27,240.45v-16.84h3.53v14.12h9.03v2.72h-12.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "cls-3-BE-P3",
    d: "m567.81,228.63c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-3-BE-P3",
    d: "m585.87,240.45h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-3-BE-P3",
    d: "m603.39,237.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-3-BE-P3",
    d: "m613.57,230.26c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-3-BE-P3",
    d: "m619.89,227.28c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-3-BE-P3",
    d: "m630.48,225.24v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-3-BE-P3",
    d: "m648.47,236.17c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-3-BE-P3",
    d: "m656.96,240.25c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-BE-P3",
    d: "m583.1,100.17l.28,35.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.6,100.17h-1v-.5h1v.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-BE-P3",
    d: "m583.5,150.57l-4.75-14.22,9.27-.07-4.52,14.29Z"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3",
    d: "m411.97,438.57c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v91.47c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-91.47Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "cls-16-BE-P3",
    d: "m430.28,472.61c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84Zm2.24,15.01c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "cls-16-BE-P3",
    d: "m458.39,476.61c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "cls-16-BE-P3",
    d: "m470.75,474.51v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-16-BE-P3",
    d: "m489.09,476.27c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-4",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m503.68,476.27c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG-2",
    "data-name": "aG",
    className: "cls-16-BE-P3",
    d: "m512.1,489.45v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-4",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m517.47,473.76v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "cls-16-BE-P3",
    d: "m528.54,489.45h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-5",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m540.21,476.27c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-3",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m554.75,478.38c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-5",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m564.25,479.74c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-16-BE-P3",
    d: "m587.47,489.45v-7.81h-9.1v7.81h-2.24v-16.84h2.24v7.13h9.1v-7.13h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "cls-16-BE-P3",
    d: "m600.31,474.51v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE-3",
    "data-name": "aE",
    className: "cls-16-BE-P3",
    d: "m622.85,489.45l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-2",
    "data-name": "aJ",
    className: "cls-16-BE-P3",
    d: "m628.89,489.45v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax-4",
    "data-name": "ax",
    className: "cls-16-BE-P3",
    d: "m654.15,476.27c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-5",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m669.5,487c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-16-BE-P3",
    d: "m680.02,477.97c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-16-BE-P3",
    d: "m695.44,489.45l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-6",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m707.52,487c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-16-BE-P3",
    d: "m723.55,476.55c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-6",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m731.9,476.27c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "rect9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20-BE-P3",
    d: "m.5,192.3c0-3.31,2.69-6,6-6h184.03c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.66Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-3-BE-P3",
    d: "m39.23,229.09c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-2",
    "data-name": "aP",
    className: "cls-3-BE-P3",
    d: "m56.61,238.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-3",
    "data-name": "aP",
    className: "cls-3-BE-P3",
    d: "m70.19,238.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-3-BE-P3",
    d: "m79.63,224.61c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84Zm3.53,8.22c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-3-BE-P3",
    d: "m102.04,230.78c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-3-BE-P3",
    d: "m118.2,239.14c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-3-BE-P3",
    d: "m132.05,232.08c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-4",
    "data-name": "aP",
    className: "cls-3-BE-P3",
    d: "m148.89,238.19c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-3-BE-P3",
    d: "m169.05,229.09c0,5.3-5.7,5.84-7.54,9.57h7.81v2.78h-11.81c-.41-6.86,6.72-6.79,8.15-12.22.07-1.49-.81-2.1-2.24-2.17-1.56,0-2.17.95-2.38,2.31l-3.33-.2c.34-3.06,2.17-4.75,5.7-4.75s5.64,1.49,5.64,4.69"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3-NA",
    d: "m1017.3,183.4c0-3.31,2.69-6,6-6h228c3.31,0,6,2.69,6,6v115.34c0,3.31-2.69,6-6,6h-228c-3.31,0-6-2.69-6-6v-115.34Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aF-2",
    "data-name": "aF",
    className: "cls-16-BE-P3",
    d: "m1092.71,193.49c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-4",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m1102.69,192.47c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-16-BE-P3",
    d: "m1123.74,194.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-2",
    "data-name": "bf",
    className: "cls-16-BE-P3",
    d: "m1144.04,194.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-7",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m1156.88,192.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m1171.61,192.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-5",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m1181.25,202.45c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-6",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m1193.2,195.94c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq-7",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m1038.22,225.27c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "cls-16-BE-P3",
    d: "m1046.98,235.25c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-16-BE-P3",
    d: "m1062.66,221.81c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-3",
    "data-name": "bf",
    className: "cls-16-BE-P3",
    d: "m1082.69,223.5c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-5",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m1090.37,219.29v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-6",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m1098.11,231.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-7",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m1104.9,231.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-8",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m1114.47,221.81c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "cls-16-BE-P3",
    d: "m1127.03,221.81c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-8",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m1145.64,231.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-5",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m1155.21,221.81c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "cls-16-BE-P3",
    d: "m1170.83,218.14c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84Zm2.24,15.01c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "cls-16-BE-P3",
    d: "m1198.94,222.14c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "cls-16-BE-P3",
    d: "m1211.3,220.04v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-6",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m1230.65,221.81c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-4",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m1245.18,223.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA-7",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m1051.22,261.87c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-2",
    "data-name": "aY",
    className: "cls-16-BE-P3",
    d: "m1067.25,251.41c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-9",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m1075.6,251.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-3",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m1090.33,251.14c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-2",
    "data-name": "aW",
    className: "cls-16-BE-P3",
    d: "m1102.49,252.84c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "cls-16-BE-P3",
    d: "m1120.34,251.41l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "cls-16-BE-P3",
    d: "m1134.06,248.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-7",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m1140.78,251.14c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-5",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m1155.31,253.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-3",
    "data-name": "aB",
    className: "cls-16-BE-P3",
    d: "m1169.3,248.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "cls-16-BE-P3",
    d: "m1174.94,264.58c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-6",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m1190.55,253.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-9",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m1194.9,261.12c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "cls-16-BE-P3",
    d: "m1204.88,252.84c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-10",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m1218.05,251.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-7",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m1232.59,253.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA-8",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m1103.44,291.2c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-4",
    "data-name": "bf",
    className: "cls-16-BE-P3",
    d: "m1121.7,282.17c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-11",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m1134.54,280.47c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-4",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m1149.27,280.47c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "cls-16-BE-P3",
    d: "m1160.68,280.47c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-8",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m1177.65,283.94c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21-BE-P3",
    d: "m237.04,236.13h-23.62v-1h23.63v1Zm178.07,0h-16.86v-1h16.87v1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17-BE-P3",
    d: "m415.6,235.63l.07.5h-.57v-1h.57l-.07.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21-BE-P3",
    d: "m415.64,235.63l.06.52h-.62v-1.05h.62l-.06.53Zm-.5-.48v.95h.5l-.05-.47.04-.48h-.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17-BE-P3",
    d: "m212.92,240.27l-14.27-4.64,14.27-4.64v9.28Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21-BE-P3",
    d: "m213.42,240.95l-16.4-5.32,16.4-5.32v10.64Zm-13.15-5.32l12.15,3.95v-7.9l-12.15,3.95Z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "cls-13-BE-P3",
    d: "m294.6,214.04c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "cls-13-BE-P3",
    d: "m308.45,222.59c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "cls-13-BE-P3",
    d: "m318.16,225.85h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "cls-13-BE-P3",
    d: "m324.74,210.64v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "cls-13-BE-P3",
    d: "m339.14,216.48c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-2",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m355.98,222.59c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "cls-13-BE-P3",
    d: "m246.08,252.88c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "cls-13-BE-P3",
    d: "m259.8,242.01c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "cls-13-BE-P3",
    d: "m271.48,242.01c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bi-2",
    "data-name": "bi",
    className: "cls-13-BE-P3",
    d: "m303.46,243.37c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-3",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m317.31,251.93c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-2",
    "data-name": "bm",
    className: "cls-13-BE-P3",
    d: "m327.63,245.81c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "cls-13-BE-P3",
    d: "m337.68,255.46c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "cls-13-BE-P3",
    d: "m355.94,242.01c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51Zm-1.43,11.14c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "cls-13-BE-P3",
    d: "m376.59,244.52c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-2",
    "data-name": "bl",
    className: "cls-13-BE-P3",
    d: "m385.07,239.98v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "cls-13-BE-P3",
    d: "m397.98,254.98c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m806.86,236.13h-54.96v-1h54.96v1Zm193.54,0h-39.06v-1h39.06v1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m751.92,236.13h-.57l.06-.5-.05-.5h.57v1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m751.95,236.15h-.63l.06-.52-.06-.53h.63v1.05Zm-.57-1l.05.48-.05.47h.52v-.95h-.52Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m1015.17,235.63l-14.27,4.64v-9.28l14.27,4.64Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m1016.8,235.63l-16.4,5.32v-10.64l16.4,5.32Zm-15.4,3.95l12.15-3.94-12.15-3.95v7.89Z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "cls-13-BE-P3",
    d: "m840.75,225.85l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46Zm-2.24-6.93l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "cls-13-BE-P3",
    d: "m853.99,212.68c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv-2",
    "data-name": "bv",
    className: "cls-13-BE-P3",
    d: "m868.86,212.68c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw",
    className: "cls-13-BE-P3",
    d: "m883.73,215.67c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx",
    className: "cls-13-BE-P3",
    d: "m891.54,212.68c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk-2",
    "data-name": "bk",
    className: "cls-13-BE-P3",
    d: "m907.63,225.85h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-4",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m925.08,222.59c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-2",
    "data-name": "bp",
    className: "cls-13-BE-P3",
    d: "m932.07,212.68c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "by",
    className: "cls-13-BE-P3",
    d: "m822.55,255.18h-3.53l-2.65-10.52-2.72,10.52h-3.53l-3.33-12.9h3.12l2.17,9.85c.61-3.53,1.63-6.59,2.44-9.85h3.6l2.51,9.85,2.17-9.85h3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-3",
    "data-name": "bl",
    className: "cls-13-BE-P3",
    d: "m827.57,239.98v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-2",
    "data-name": "bt",
    className: "cls-13-BE-P3",
    d: "m840.48,254.98c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz",
    className: "cls-13-BE-P3",
    d: "m848.49,244.52c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bA",
    className: "cls-13-BE-P3",
    d: "m875.31,250.91c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bz-2",
    "data-name": "bz",
    className: "cls-13-BE-P3",
    d: "m883.73,244.52c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn-2",
    "data-name": "bn",
    className: "cls-13-BE-P3",
    d: "m899.89,252.88c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-2",
    "data-name": "bo",
    className: "cls-13-BE-P3",
    d: "m913.61,242.01c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB",
    className: "cls-13-BE-P3",
    d: "m932.55,254.78c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49Zm-6.11-1.97c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-5",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m946.74,251.93c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-3",
    "data-name": "bm",
    className: "cls-13-BE-P3",
    d: "m957.06,245.81c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m582.63,415.7h-1v-23.4h1v23.4Zm1.38-82.08h-1v-14.06h1v14.06Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m583.5,319.07l.5-.03v.53h-1v-.53l.5.03Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.5,319.04l.54-.03v.6h-1.05v-.6l.51.03Zm-.46.5h.95v-.48l-.5.02-.46-.03v.49Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m582.13,430.47l-4.63-14.28h9.27l-4.64,14.28Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m582.13,432.07l-5.32-16.37h10.66l-5.34,16.37Zm-3.95-15.37l3.95,12.14,3.95-12.14h-7.9Z"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "G-2",
    "data-name": "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bu-2",
    "data-name": "bu",
    className: "cls-13-BE-P3",
    d: "m540.16,353.18l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46Zm-2.24-6.93l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv-3",
    "data-name": "bv",
    className: "cls-13-BE-P3",
    d: "m553.4,340c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bv-4",
    "data-name": "bv",
    className: "cls-13-BE-P3",
    d: "m568.27,340c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw-2",
    "data-name": "bw",
    className: "cls-13-BE-P3",
    d: "m583.14,342.99c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-2",
    "data-name": "bx",
    className: "cls-13-BE-P3",
    d: "m590.95,340c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk-3",
    "data-name": "bk",
    className: "cls-13-BE-P3",
    d: "m607.04,353.18h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-6",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m624.49,349.92c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-3",
    "data-name": "bp",
    className: "cls-13-BE-P3",
    d: "m631.49,340c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bC",
    className: "cls-13-BE-P3",
    d: "m507.81,367.16c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-3",
    "data-name": "bx",
    className: "cls-13-BE-P3",
    d: "m515.14,369.34c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw-3",
    "data-name": "bw",
    className: "cls-13-BE-P3",
    d: "m531.71,372.32c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bD",
    className: "cls-13-BE-P3",
    d: "m540.47,365.67c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84Zm3.53,8.22c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw-4",
    "data-name": "bw",
    className: "cls-13-BE-P3",
    d: "m564.3,372.32c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-4",
    "data-name": "bx",
    className: "cls-13-BE-P3",
    d: "m572.11,369.34c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-4",
    "data-name": "bp",
    className: "cls-13-BE-P3",
    d: "m585.49,369.34c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-2",
    "data-name": "bq",
    className: "cls-13-BE-P3",
    d: "m600.15,382.78c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA-2",
    "data-name": "bA",
    className: "cls-13-BE-P3",
    d: "m622.15,378.23c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-3",
    "data-name": "bt",
    className: "cls-13-BE-P3",
    d: "m630.64,382.31c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-4",
    "data-name": "bl",
    className: "cls-13-BE-P3",
    d: "m632.61,367.3v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-5",
    "data-name": "bx",
    className: "cls-13-BE-P3",
    d: "m645.17,369.34c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-3",
    "data-name": "bo",
    className: "cls-13-BE-P3",
    d: "m661.74,369.34c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3",
    d: "m411.53,591.37c0-3.31,2.69-6,6-6h330.27c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.28c-3.31,0-6-2.69-6-6v-86.67Z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "i-2",
    "data-name": "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aH-2",
    "data-name": "aH",
    className: "cls-16-BE-P3",
    d: "m481.62,640.52v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-5",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m494.12,627.35c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-6",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m501.38,624.83v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-10",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m509.12,637.33c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-7",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m513.54,624.83v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-9",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m526.85,638.07c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-11",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m534.86,637.33c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-12",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m544.43,627.35c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aF-3",
    "data-name": "aF",
    className: "cls-16-BE-P3",
    d: "m572.41,628.36c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-13",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m582.39,627.35c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-8",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m596.92,629.45c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-12",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m601.27,637.33c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-8",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m605.68,624.83v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-4",
    "data-name": "aB",
    className: "cls-16-BE-P3",
    d: "m616.27,624.63c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-9",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m617.83,624.83v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-3",
    "data-name": "aW",
    className: "cls-16-BE-P3",
    d: "m628.09,629.04c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-10",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m643.36,638.07c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-13",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m651.38,637.33c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-10",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m655.79,624.83v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-8",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m666.31,627.35c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-6",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m681.05,627.35c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-BE-P3",
    d: "m583.1,537.04l-.3,31.45"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.6,537.05h-1v-.5h1v.5Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-BE-P3",
    d: "m582.67,583.25l-4.5-14.3,9.27.08-4.77,14.22Z"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "diamond2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7-BE-P3",
    d: "m578.13,739.3c3.39-1.67,7.37-1.67,10.76,0l160.36,79.02c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.35,79.05c-3.4,1.67-7.38,1.67-10.77,0l-160.36-79.02c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.36-79.05Z"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bE",
    className: "cls-3-BE-P3",
    d: "m472.78,817.31c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-5",
    "data-name": "aP",
    className: "cls-3-BE-P3",
    d: "m498.38,822.54c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-2",
    "data-name": "aQ",
    className: "cls-3-BE-P3",
    d: "m508.56,815.61c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-2",
    "data-name": "aU",
    className: "cls-3-BE-P3",
    d: "m516.71,825.59c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "cls-3-BE-P3",
    d: "m518.68,810.59v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bF",
    className: "cls-3-BE-P3",
    d: "m531.99,810.45c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-3",
    "data-name": "aS",
    className: "cls-3-BE-P3",
    d: "m533.55,810.59v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-2",
    "data-name": "aT",
    className: "cls-3-BE-P3",
    d: "m551.54,821.52c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc-2",
    "data-name": "bc",
    className: "cls-3-BE-P3",
    d: "m561.25,823.49c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-3",
    "data-name": "aU",
    className: "cls-3-BE-P3",
    d: "m573.61,825.59c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-4",
    "data-name": "aS",
    className: "cls-3-BE-P3",
    d: "m575.58,810.59v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bG",
    className: "cls-3-BE-P3",
    d: "m588.14,812.62c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bH",
    className: "cls-3-BE-P3",
    d: "m604.71,812.62c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-3-BE-P3",
    d: "m627.19,825.8h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aP-6",
    "data-name": "aP",
    className: "cls-3-BE-P3",
    d: "m644.7,822.54c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aQ-3",
    "data-name": "aQ",
    className: "cls-3-BE-P3",
    d: "m654.89,815.61c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR-2",
    "data-name": "aR",
    className: "cls-3-BE-P3",
    d: "m661.2,812.62c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-5",
    "data-name": "aS",
    className: "cls-3-BE-P3",
    d: "m671.8,810.59v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT-3",
    "data-name": "aT",
    className: "cls-3-BE-P3",
    d: "m689.79,821.52c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aU-4",
    "data-name": "aU",
    className: "cls-3-BE-P3",
    d: "m698.28,825.59c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-BE-P3",
    d: "m582.67,685.04l.58,36.12"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.17,685.04l-1,.02v-.53h1v.51Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-BE-P3",
    d: "m583.5,735.93l-4.88-14.2,9.27-.14-4.39,14.34Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m99.02,814.97l.07.87.2.83.32.8.46.74.56.65.65.55.73.46.8.33.83.2.88.08h130.78v1H104.5l-1-.07-.98-.24-.95-.4-.87-.54-.77-.66-.67-.77-.53-.87-.4-.95-.23-.98-.08-1V301.87h1v513.1Zm316.1,5.5v1h-33.64v-1h33.64Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m415.6,820.97l.07.5h-.57v-1h.57l-.07.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m415.64,820.97l.06.53h-.62v-1.05h.62l-.06.52Zm-.5-.47v.95h.5l-.05-.47.04-.47h-.49Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m103.16,301.35h-9.26l4.6-14.28,4.66,14.28Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m103.85,301.85h-10.65l5.32-16.4,5.33,16.4Zm-9.27-1h7.9l-3.98-12.15-3.92,12.15Z"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bI",
    className: "cls-13-BE-P3",
    d: "m247.17,825.86l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bx-6",
    "data-name": "bx",
    className: "cls-13-BE-P3",
    d: "m260.35,812.69c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-4",
    "data-name": "bt",
    className: "cls-13-BE-P3",
    d: "m275.56,825.66c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bJ",
    className: "cls-13-BE-P3",
    d: "m287.17,817.38c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-7",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m312.77,822.61c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw-5",
    "data-name": "bw",
    className: "cls-13-BE-P3",
    d: "m322.95,815.68c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-5",
    "data-name": "bt",
    className: "cls-13-BE-P3",
    d: "m331.1,825.66c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-5",
    "data-name": "bl",
    className: "cls-13-BE-P3",
    d: "m333.07,810.65v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-2",
    "data-name": "bC",
    className: "cls-13-BE-P3",
    d: "m346.38,810.52c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-6",
    "data-name": "bl",
    className: "cls-13-BE-P3",
    d: "m347.94,810.65v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-8",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m365.59,822.61c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-5",
    "data-name": "bp",
    className: "cls-13-BE-P3",
    d: "m372.59,812.69c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m906.2,821.47h-154.3v-1h154.3v1Zm386.6-580.82l1,.24.94.4.87.52.78.66.67.78.53.87.4.94.23.98.1,1v567.95l-.1,1-.23.98-.4.96-.52.87-.67.77-.77.66-.86.54-.94.4-1,.23-1,.08h-138.93v-1h138.9l.88-.06.83-.2.8-.33.74-.45.65-.56.56-.66.45-.74.34-.8.2-.83.07-.88V247.07l-.08-.88-.2-.84-.34-.8-.45-.73-.56-.66-.65-.55-.74-.45-.8-.33-.83-.2-.88-.07h-17.6v-1h17.64l.97.09Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m751.92,821.47h-.57l.06-.5-.05-.5h.57v1Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m751.95,821.5h-.63l.06-.53-.06-.52h.63v1.05Zm-.57-1l.05.47-.05.48h.52v-.95h-.52Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m1273.67,245.7l-14.27-4.63,14.27-4.64v9.27Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m1274.17,246.39l-16.38-5.32,16.37-5.32v10.64Zm-13.15-5.32l12.15,3.95v-7.9l-12.15,3.95Z"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bi-3",
    "data-name": "bi",
    className: "cls-13-BE-P3",
    d: "m922.49,814.05c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-9",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m936.34,822.61c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk-4",
    "data-name": "bk",
    className: "cls-13-BE-P3",
    d: "m946.05,825.86h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-7",
    "data-name": "bl",
    className: "cls-13-BE-P3",
    d: "m952.64,810.65v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-4",
    "data-name": "bm",
    className: "cls-13-BE-P3",
    d: "m967.03,816.49c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-10",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m983.87,822.61c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bn-3",
    "data-name": "bn",
    className: "cls-13-BE-P3",
    d: "m1000.71,823.56c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-4",
    "data-name": "bo",
    className: "cls-13-BE-P3",
    d: "m1014.43,812.69c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-6",
    "data-name": "bp",
    className: "cls-13-BE-P3",
    d: "m1026.11,812.69c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bi-4",
    "data-name": "bi",
    className: "cls-13-BE-P3",
    d: "m1058.09,814.05c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-11",
    "data-name": "bj",
    className: "cls-13-BE-P3",
    d: "m1071.94,822.61c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-5",
    "data-name": "bm",
    className: "cls-13-BE-P3",
    d: "m1082.26,816.49c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-3",
    "data-name": "bq",
    className: "cls-13-BE-P3",
    d: "m1092.31,826.14c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "br-2",
    "data-name": "br",
    className: "cls-13-BE-P3",
    d: "m1110.57,812.69c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51Zm-1.43,11.14c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-2",
    "data-name": "bs",
    className: "cls-13-BE-P3",
    d: "m1131.22,815.2c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-8",
    "data-name": "bl",
    className: "cls-13-BE-P3",
    d: "m1139.7,810.65v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-6",
    "data-name": "bt",
    className: "cls-13-BE-P3",
    d: "m1152.61,825.66c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3",
    d: "m412.4,1018.57c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v86.7c0,3.31-2.69,6-6,6h-330.24c-3.31,0-6-2.69-6-6v-86.7Z"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "cls-16-BE-P3",
    d: "m445.09,1052.79v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-11",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m457.32,1052.04v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-7",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m469,1054.56c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-11",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m484.21,1065.28c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG-3",
    "data-name": "aG",
    className: "cls-16-BE-P3",
    d: "m489.84,1067.73v-17.72h2.17v17.72h-2.17"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq-9",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m509.53,1058.02c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-14",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m516.59,1064.54c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-14",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m526.17,1054.56c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-5",
    "data-name": "ax",
    className: "cls-16-BE-P3",
    d: "m540.77,1054.56c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-10",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m555.71,1058.02c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-16-BE-P3",
    d: "m573.36,1054.56c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-15",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m585.92,1054.56c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-5",
    "data-name": "aB",
    className: "cls-16-BE-P3",
    d: "m599.57,1051.84c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-9",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m606.29,1054.56c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-9",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m620.82,1056.66c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-16",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m627.95,1054.56c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bK",
    className: "cls-16-BE-P3",
    d: "m651.24,1068c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-10",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m667.34,1054.56c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bL",
    className: "cls-16-BE-P3",
    d: "m675.21,1062.16v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-3",
    "data-name": "aJ",
    className: "cls-16-BE-P3",
    d: "m684.24,1067.73v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-12",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m697.42,1052.04v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "cls-16-BE-P3",
    d: "m708.48,1067.73h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-17",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m720.16,1054.56c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m584,995.7h-1v-39.68h1v39.68Zm0-69h-1v-21.8h1v21.8Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m583.5,904.41l.5-.03v.55h-1v-.54l.5.02Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.5,904.37h.54v.57h-1.05v-.58h.51Zm-.46.52h.95v-.48l-.5.02-.46-.02v.48Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m583.5,1010.47l-4.62-14.27h9.27l-4.65,14.27Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.5,1012.07l-5.3-16.37h10.63l-5.33,16.37Zm-3.94-15.37l3.95,12.14,3.96-12.14h-7.91Z"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bM",
    className: "cls-14-BE-P3",
    d: "m538.63,937.76c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bN",
    className: "cls-14-BE-P3",
    d: "m564.23,942.98c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO",
    className: "cls-14-BE-P3",
    d: "m574.42,936.06c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP",
    className: "cls-14-BE-P3",
    d: "m582.57,946.04c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bQ",
    className: "cls-14-BE-P3",
    d: "m584.53,931.03v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bR",
    className: "cls-14-BE-P3",
    d: "m597.84,930.9c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bQ-2",
    "data-name": "bQ",
    className: "cls-14-BE-P3",
    d: "m599.4,931.03v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bN-2",
    "data-name": "bN",
    className: "cls-14-BE-P3",
    d: "m617.06,942.98c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bS",
    className: "cls-14-BE-P3",
    d: "m624.05,933.07c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.16,1201.64h-1v-22.1h1v22.1Zm.85-51.42h-1v-37.97h1v37.97Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m584,1112.27h-1v-.52h1v.52Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m584.04,1112.27h-1.05v-.55h1.04v.55Zm-1-.5v.46h.95v-.46h-.95Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12-BE-P3",
    d: "m582.66,1216.4l-4.63-14.26h9.26l-4.63,14.26Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m582.66,1218.02l-5.32-16.38h10.64l-5.32,16.38Zm-3.95-15.38l3.96,12.14,3.95-12.13h-7.91Z"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bT",
    className: "cls-14-BE-P3",
    d: "m448.37,1169.77l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46Zm-2.24-6.93l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU",
    className: "cls-14-BE-P3",
    d: "m461.62,1156.6c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-2",
    "data-name": "bU",
    className: "cls-14-BE-P3",
    d: "m476.49,1156.6c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO-2",
    "data-name": "bO",
    className: "cls-14-BE-P3",
    d: "m491.36,1159.59c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV",
    className: "cls-14-BE-P3",
    d: "m499.16,1156.6c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bW",
    className: "cls-14-BE-P3",
    d: "m515.26,1169.77h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bN-3",
    "data-name": "bN",
    className: "cls-14-BE-P3",
    d: "m532.71,1166.51c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bS-2",
    "data-name": "bS",
    className: "cls-14-BE-P3",
    d: "m539.7,1156.6c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bR-2",
    "data-name": "bR",
    className: "cls-14-BE-P3",
    d: "m563.6,1154.43c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV-2",
    "data-name": "bV",
    className: "cls-14-BE-P3",
    d: "m570.94,1156.6c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO-3",
    "data-name": "bO",
    className: "cls-14-BE-P3",
    d: "m587.5,1159.59c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bX",
    className: "cls-14-BE-P3",
    d: "m596.26,1152.93c8.15-.48,15.14.34,15.01,8.28-.07,5.43-2.99,8.56-8.22,8.56h-6.79v-16.84Zm3.53,14.12c5.02.48,7.94-1.22,7.94-5.84s-3.06-5.98-7.94-5.57v11.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bQ-3",
    "data-name": "bQ",
    className: "cls-14-BE-P3",
    d: "m613.92,1154.56v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bY",
    className: "cls-14-BE-P3",
    d: "m628.31,1160.4c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP-2",
    "data-name": "bP",
    className: "cls-14-BE-P3",
    d: "m640.4,1169.57c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bO-4",
    "data-name": "bO",
    className: "cls-14-BE-P3",
    d: "m649.84,1159.59c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bQ-4",
    "data-name": "bQ",
    className: "cls-14-BE-P3",
    d: "m651.87,1154.56v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bZ",
    className: "cls-14-BE-P3",
    d: "m666.13,1156.6c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51Zm-1.43,11.14c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ca",
    className: "cls-14-BE-P3",
    d: "m677.61,1170.04c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP-3",
    "data-name": "bP",
    className: "cls-14-BE-P3",
    d: "m694.52,1169.57c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bQ-5",
    "data-name": "bQ",
    className: "cls-14-BE-P3",
    d: "m696.49,1154.56v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bV-3",
    "data-name": "bV",
    className: "cls-14-BE-P3",
    d: "m709.05,1156.6c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb",
    className: "cls-14-BE-P3",
    d: "m725.62,1156.6c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  })))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-BE-P3",
    d: "m582.66,1318.19v38.08"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m583.16,1318.2h-1v-.5h1v.5Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-BE-P3",
    d: "m582.66,1371.03l-4.63-14.27h9.26l-4.63,14.27Z"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3",
    d: "m411.12,1379.15c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-86.66Z"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "cls-16-BE-P3",
    d: "m433.1,1398.78c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-4",
    "data-name": "aW",
    className: "cls-16-BE-P3",
    d: "m443.35,1400.13c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-3",
    "data-name": "az",
    className: "cls-16-BE-P3",
    d: "m456.25,1400.13c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-18",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m469.43,1398.44c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "cls-16-BE-P3",
    d: "m481.99,1398.44c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-4",
    "data-name": "ay",
    className: "cls-16-BE-P3",
    d: "m495.5,1411.88c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG-4",
    "data-name": "aG",
    className: "cls-16-BE-P3",
    d: "m505.01,1411.61v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-19",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m515.53,1398.44c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-6",
    "data-name": "an",
    className: "cls-16-BE-P3",
    d: "m528.09,1398.44c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cc",
    className: "cls-16-BE-P3",
    d: "m553.56,1402.71c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87Zm-6.59-.75c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36Zm0,7.81c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-10",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m566.73,1400.54c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-11",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m573.86,1398.44c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-12",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m590.22,1409.16c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-7",
    "data-name": "an",
    className: "cls-16-BE-P3",
    d: "m600,1398.44c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-5",
    "data-name": "aW",
    className: "cls-16-BE-P3",
    d: "m614.33,1400.13c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-13",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m629.6,1409.16c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-11",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m642.78,1401.9c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-15",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m649.84,1408.42c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cd",
    className: "cls-16-BE-P3",
    d: "m661.45,1411.61v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-5",
    "data-name": "bf",
    className: "cls-16-BE-P3",
    d: "m689.97,1400.13c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-14",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m705.59,1409.16c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-13",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m711.22,1395.92v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG-5",
    "data-name": "aG",
    className: "cls-16-BE-P3",
    d: "m716.59,1411.61v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-14",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m728.74,1395.92v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-12",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m741.64,1401.9c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq-13",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m548.33,1431.23c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-20",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m558.17,1427.77c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-8",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m572.91,1427.77c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-16",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m582.55,1437.75c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aw-12",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m598.91,1427.77c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-5",
    "data-name": "ay",
    className: "cls-16-BE-P3",
    d: "m611.41,1441.21c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-17",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m623.29,1437.75c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-BE-P3",
    d: "m408.94,1533.77c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.27c-3.31,0-6-2.69-6-6v-86.67Z"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aH-3",
    "data-name": "aH",
    className: "cls-16-BE-P3",
    d: "m451.87,1566.24v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-9",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m464.36,1553.06c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-6",
    "data-name": "aB",
    className: "cls-16-BE-P3",
    d: "m476.86,1550.35c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-13",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m483.58,1553.06c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-11",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m498.11,1555.17c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-6",
    "data-name": "bf",
    className: "cls-16-BE-P3",
    d: "m512.71,1554.76c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aF-4",
    "data-name": "aF",
    className: "cls-16-BE-P3",
    d: "m539.94,1554.08c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-6",
    "data-name": "ay",
    className: "cls-16-BE-P3",
    d: "m548.83,1566.51c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-14",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m565.87,1556.53c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-18",
    "data-name": "av",
    className: "cls-16-BE-P3",
    d: "m572.94,1563.04c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-14",
    "data-name": "aw",
    className: "cls-16-BE-P3",
    d: "m582.51,1553.06c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-7",
    "data-name": "bf",
    className: "cls-16-BE-P3",
    d: "m603.56,1554.76c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-21",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m616.39,1553.06c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC-12",
    "data-name": "aC",
    className: "cls-16-BE-P3",
    d: "m630.92,1555.17c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aD-3",
    "data-name": "aD",
    className: "cls-16-BE-P3",
    d: "m642.33,1551.3v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-15",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m662.5,1563.79c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW-6",
    "data-name": "aW",
    className: "cls-16-BE-P3",
    d: "m673.02,1554.76c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-15",
    "data-name": "ap",
    className: "cls-16-BE-P3",
    d: "m680.36,1550.55v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aI-10",
    "data-name": "aI",
    className: "cls-16-BE-P3",
    d: "m692.04,1553.06c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY-3",
    "data-name": "aY",
    className: "cls-16-BE-P3",
    d: "m709.69,1553.33c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "cls-16-BE-P3",
    d: "m553.14,1580.63v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-22",
    "data-name": "ar",
    className: "cls-16-BE-P3",
    d: "m563.46,1582.4c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-16",
    "data-name": "aA",
    className: "cls-16-BE-P3",
    d: "m579.83,1593.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf-8",
    "data-name": "bf",
    className: "cls-16-BE-P3",
    d: "m598.09,1584.09c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-15",
    "data-name": "aq",
    className: "cls-16-BE-P3",
    d: "m613.3,1585.86c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-BE-P3",
    d: "m581.53,1472.81l-.53,38.08"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m582.03,1472.83h-1v-.52h1v.52Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-BE-P3",
    d: "m580.8,1525.67l-4.44-14.34,9.27.13-4.83,14.21Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11-BE-P3",
    d: "m1137.3,305.74v178.57h-366.2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8-BE-P3",
    d: "m1137.8,305.75h-1v-.5h1v.5Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10-BE-P3",
    d: "m756.34,484.31l14.26-4.64v9.27l-14.26-4.63Z"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    xlinkHref: "#popup_flight_travlDil11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18-BE-P3",
    d: "m155.03,799.79h32.05v20.28h-32.05v-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15-BE-P3",
    d: "m155,820.17h32.06v20.87h-32.06v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-BE-P3",
    d: "m187.08,799.79h32.96v20.87h-32.96v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-BE-P3",
    d: "m187.08,820.17h32.96v20.87h-32.96v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "m153.1,808.89h33.96v2.67h-33.96v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "m169.15,799.75v20.32h-2.96v-20.32h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "m201.88,799.85v20.33h-3.42v-20.31l3.42-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "m219.85,812.02h-32.83v-3.42h32.83v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-BE-P3",
    d: "m169.33,820.17v20.94h-3.42v-20.94h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-BE-P3",
    d: "m187.13,832.89h-32.1v-3.42h32.1v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "m201.88,820.07v20.96h-3.42v-20.96h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "m220.04,832.89h-33.02v-3.42h33.02v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "m201.2,820.07v21h-2.07v-21h2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "m220.07,832.22h-33v-2.08h33v2.08Z"
  }))), _a2 || (_a2 = /*#__PURE__*/React.createElement("a", {
    xlinkHref: "#popup_flight_travlDil12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18-BE-P3",
    d: "M334.91,1035.88h32.05v20.28h-32.05v-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15-BE-P3",
    d: "M334.88,1056.26h32.06v20.87h-32.06v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-BE-P3",
    d: "M366.96,1035.88h32.96v20.87h-32.96v-20.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-BE-P3",
    d: "M366.96,1056.26h32.96v20.87h-32.96v-20.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "M332.98,1044.98h33.96v2.67h-33.96v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "M349.03,1035.84v20.32h-2.96v-20.32h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "M381.76,1035.93v20.33h-3.42v-20.31l3.42-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "M399.73,1048.11h-32.83v-3.42h32.83v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-BE-P3",
    d: "M349.21,1056.26v20.94h-3.42v-20.94h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-BE-P3",
    d: "M367.01,1068.98h-32.1v-3.42h32.1v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "M381.76,1056.16v20.96h-3.42v-20.96h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-BE-P3",
    d: "M399.92,1068.98h-33.02v-3.42h33.02v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "M381.08,1056.16v21h-2.07v-21h2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-BE-P3",
    d: "M399.95,1068.3h-33v-2.08h33v2.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBePhase3);
export default __webpack_public_path__ + "static/media/BE_Phase_3.6dd5a698f40e94bb0d5306e5c0e171d7.svg";
export { ForwardRef as ReactComponent };